import classNames from 'classnames/bind';
import React from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem } from 'semantic-ui-react';
import { Modal, ModalWidth } from '@creditsights/styleguide-web';

import useFetchIssuersByIds from '../../../hooks/issuers/useFetchIssuersByIds';
import { Tag } from '../../../models';
import { getIssuerRoute } from '../../../utils/navigationUtils';
import { extractIssuerIds } from '../../../utils/tagUtils';
import { useGlobalModalContext } from '../../GlobalModal';
import WeightIcon from '../../WeightIcon';
import styles from './CompaniesWeightModal.module.scss';

const cx = classNames.bind(styles);

interface CompaniesWeightModalProps {
  companies: Tag[];
}

const CompaniesWeightModal = ({ companies }: CompaniesWeightModalProps): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();
  const { isLoading, data } = useFetchIssuersByIds(extractIssuerIds(companies));

  const renderWeightIcon = ({ tagId }: Tag) => {
    const iconName = data?.find((company) => company.tagId === tagId)?.latestRec?.weighting;

    return iconName ? <WeightIcon weighting={iconName} /> : <div className={cx('no-weighting')} />;
  };

  return (
    <Modal
      className={cx('body')}
      width={ModalWidth.Small}
      open
      onClose={closeModal}
      headerTitle="Companies"
      data-testid="companies-weight-modal"
      isLoading={isLoading}
    >
      <List>
        {companies.map((company) => (
          <ListItem key={`${company.tagId}-index`}>
            <div className={cx('company-item')} data-testid="company-item">
              {renderWeightIcon(company)}
              <Link to={getIssuerRoute(company.tagId)}>
                <h3 className={cx('title')} data-testid="company-field">
                  {company.name}
                </h3>
              </Link>
            </div>
          </ListItem>
        ))}
      </List>
    </Modal>
  );
};

export default CompaniesWeightModal;
